import { css, StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { media } from '../../services/media';

const SectionUpscore = ({ theme }: StyledProps) =>
    theme.version === 'upscore' &&
    css`
        margin: 0 0 80px;
    `;

const SectionPengestyrke = ({ theme }: StyledProps) =>
    theme.version === 'pengestyrke' &&
    css`
        position: relative;

        max-width: 1200px;
        margin: 20px auto;
        padding: 40px 15px 0;

        display: flex;
        justify-content: center;

        background-color: #eef0eb;

        h2 {
            font-size: 62px;
        }
    `;

export const Section = styled.section`
    display: flex;
    justify-content: center;
    font-family: ${(props) => props.theme.body.fontFamily};

    ${media.max('md')} {
        margin: 0 0 40px;
    }

    ${SectionUpscore}
    ${SectionPengestyrke}

    // Hides first Y tick on graph
    .recharts-wrapper
        .recharts-yAxis
        .recharts-cartesian-axis-tick:first-of-type {
        display: none;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    text-align: center;
    position: relative;
`;

export const GraphWrapper = styled.div`
    margin: 0 0 40px;

    ${media.max('md')} {
        overflow-y: auto;
        padding: 0 0 5px;
        margin: 0 0 5px;

        .recharts-responsive-container {
            width: 600px !important;
        }
    }
`;

export const ScrollIndicator = styled.div`
    transition: 450ms ease-in-out;
    position: absolute;
    font-size: 14px;
    top: 65%;
    left: 10px;
    opacity: 0;
    pointer-events: none;

    &.active {
        opacity: 1;
    }
`;
